export const MEASURE_FIELDS = [
  { key: "length", ar: "الطول", en: "Length", hint: "من الكتف حتى أسفل العباية", hint_en: "From shoulder to the abaya hem" },
  { key: "shoulder", ar: "الكتف", en: "Shoulder", hint: "من طرف كتف إلى طرف الكتف الآخر", hint_en: "From one shoulder edge to the other" },
  { key: "chest", ar: "الصدر", en: "Chest", hint: "حول أوسع نقطة في الصدر", hint_en: "Around the fullest part of the chest" },
  { key: "sleeve", ar: "طول الكم", en: "Sleeve length", hint: "من الكتف حتى الرسغ", hint_en: "From shoulder to wrist" },
  { key: "hip", ar: "محيط الورك", en: "Hip", hint: "حول أوسع نقطة في الورك", hint_en: "Around the fullest part of the hips" },
];

export const fieldLabel = (f, lang) => (lang === "en" ? f.en : f.ar);

export const DEFAULT_RANGES = {
  length: { min: 100, max: 180 }, shoulder: { min: 30, max: 70 },
  chest: { min: 70, max: 140 }, sleeve: { min: 40, max: 80 }, hip: { min: 80, max: 160 },
};

export function hardMeasureError(m, lang = "ar") {
  for (const f of MEASURE_FIELDS) {
    const raw = m[f.key];
    const v = Number(raw);
    if (raw === "" || raw == null || isNaN(v) || v <= 0) return lang === "en" ? `Please enter a valid value for ${f.en} (cm)` : `يرجى إدخال قيمة صحيحة لـ ${f.ar} (بالسنتيمتر)`;
  }
  return null;
}

export function fieldWarn(key, value, ranges, lang = "ar") {
  const R = ranges || DEFAULT_RANGES;
  if (value === "" || value == null) return null;
  const v = Number(value);
  if (isNaN(v) || v <= 0) return null;
  const r = R[key];
  if (r && (v < r.min || v > r.max)) return lang === "en" ? "Outside the guide range, please double-check the number." : "القياس خارج النطاق الإرشادي، يرجى التأكد من الرقم.";
  return null;
}

export function measureErrorInRange(m, ranges, lang = "ar") {
  const R = ranges || DEFAULT_RANGES;
  const en = lang === "en";
  for (const f of MEASURE_FIELDS) {
    const raw = m[f.key];
    if (raw === "" || raw == null) return en ? `Please enter: ${f.en}` : `يرجى إدخال المقاس: ${f.ar}`;
    const v = Number(raw);
    if (isNaN(v) || v <= 0) return en ? `Please enter a valid value for ${f.en}` : `يرجى إدخال قيمة صحيحة لـ ${f.ar}`;
    const r = R[f.key];
    if (r && (v < r.min || v > r.max)) return en ? `${f.en} must be between ${r.min} and ${r.max} cm` : `قيمة ${f.ar} يجب أن تكون بين ${r.min} و ${r.max} سم`;
  }
  return null;
}

export const MEASURE_CONFIRM_TEXT = "أقر بأن المقاسات المدخلة صحيحة، وأعتمدها لتفصيل طلبي";
export const TERMS_CONFIRM_TEXT = "قرأت وأوافق على الشروط والأحكام وسياسة الاستبدال والاسترجاع";
export const ALTERATION_CONFIRM_TEXT =
  "أوافق على سياسة تعديل المقاس خلال 7 أيام من تاريخ الاستلام مع المحافظة على القطعة بحالتها الأصلية";
export const CHECKOUT_NOTICE =
  "مدة تجهيز الطلب من 5 إلى 10 أيام عمل. تُضاف مدة التوصيل بعد التجهيز بحسب المنطقة، وتظهر رسوم التوصيل منفصلة قبل الدفع.";
export const INTL_NOTICE =
  "مدة تجهيز الطلب من 5 إلى 10 أيام عمل، ثم تُضاف مدة شركة الشحن بحسب الدولة والوجهة. وتظهر رسوم الشحن منفصلة قبل الدفع.";

export const TEXT_EN = {
  measure: "I confirm the measurements entered are correct and approve them for tailoring my order",
  terms: "I have read and agree to the Terms & Conditions and the Exchange & Return Policy",
  alteration: "I agree to the 7-day alteration policy from the date of receipt, provided the piece is kept in its original condition",
  notice: "Order preparation takes 5 to 10 working days. Delivery time is added after preparation depending on the area, and the delivery fee is shown separately before payment.",
  intl: "Order preparation takes 5 to 10 working days, then the courier's time is added depending on the country and destination. The shipping fee is shown separately before payment.",
};
